import * as a from "react";
function o(r) {
  var f;
  return parseInt(a.version, 10) >= 19 ? ((f = r == null ? void 0 : r.props) == null ? void 0 : f.ref) || null : (r == null ? void 0 : r.ref) || null;
}
export {
  o as default
};
